module.exports = __webpack_public_path__ + "img/stick_divers_funslope.3535fb88.svg";